import { formatISO } from 'date-fns';

export const DEFAULT_DATE_TIME_FORMAT = 'MM-dd-yyyy HH:mm';
export const DEFAULT_DATE_FORMAT = 'MM-dd-yyyy';

export function encodeDateToURL(date: Date | null | undefined): string | null {
	if (!date) {
		return null;
	}

	return encodeURIComponent(formatISO(date));
}

export function decodeDateFromURL(date: string | null | undefined): Date | null {
	if (!date || date.length === 0) {
		return null;
	}

	return new Date(decodeURIComponent(date));
}

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function daysBetweenDates(d1: Date, d2: Date): number {
	return Math.abs((d2.getTime() - d1.getTime()) / MS_PER_DAY);
}
